<template>
	<section class="app-container form-high-contrast wide-section">
		<div class="container bulkupload-review-container">
			<div class="bulk-upload-header">
				<h1>Bulk Observation Imports</h1>
				<BulkUploadNavigation :user="current_user"></BulkUploadNavigation>
			</div>
			<div v-if="current_user && current_user.profile.vetter">
				<div class="loading-overlay" v-if="loading">
					<div class="spinner-wrapper">
						<span class="spinner-text">LOADING</span>
						<span class="spinner"></span>
					</div>
				</div>
				<Paging></Paging>
				<PagingSummary v-model="meta"></PagingSummary>
				<table class="border--round table--alternate-row">
					<thead>
						<tr>
							<th>User</th>
							<th>Name</th>
							<th>Data</th>
							<th>Vetting Option</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="upload in imports">
							<td>
								{{upload.user_data.display_name}}
							</td>
							<td>{{upload.name}}</td>
							<td>
								<div v-for="count, key in upload.status_counts">
									<strong>{{key}}: </strong>{{count}}
								</div>
								<router-link class="btn btn-sm" :to="{ path: '/data/records/', query: { filterqs: '|statuses:1,5,3,4|imports:' + upload.id }}" target="_blank">
									<i class="fa fa-external-link"></i> View Records
								</router-link><br />
							</td>
							<td>
								<div class="input-radio input-radio-left">
                                    <span class="input__label">Assign <strong><em>Pending Admin Review</em></strong> Photo and Specimen records "Accepted", all Observed Only to "Not Vetted"</span>
                                    <input type="radio" value="1" v-model.number="upload.action_id" :name="'action_id' + upload.id" :id="'action_id' + upload.id + '1'">
                                    <label :for="'action_id' + upload.id + '1'"></label>
                                </div>
                                <div class="input-radio input-radio-left">
                                    <span class="input__label">Assign <strong><em>Pending Admin Review</em></strong> to "Pending" or "Not Vetted" according to usual OC rules</span>
                                    <input type="radio" value="2" v-model.number="upload.action_id" :name="'action_id' + upload.id" :id="'action_id' + upload.id + '2'">
                                    <label :for="'action_id' + upload.id + '2'"></label>
                                </div>
                                <div class="input-radio input-radio-left">
                                    <span class="input__label">Assign <strong><em>Pending Admin Review</em></strong> "Not Vetted"</span>
                                    <input type="radio" value="3" v-model.number="upload.action_id" :name="'action_id' + upload.id" :id="'action_id' + upload.id + '3'">
                                    <label :for="'action_id' + upload.id + '3'"></label>
                                </div>
                                <div class="input-radio input-radio-left">
                                    <span class="input__label">Assign all "Pending Admin Review"</span>
                                    <input type="radio" value="4" v-model.number="upload.action_id" :name="'action_id' + upload.id" :id="'action_id' + upload.id + '4'">
                                    <label :for="'action_id' + upload.id + '4'"></label>
                                </div>
								<button class="btn btn-primary btn-xs" @click="applyAction(upload)"><span class="fa fa-check"></span> Apply</button>
							</td>
							<td>
								<button class="btn btn-danger" @click="deleteUpload(upload)"><span class="fa fa-trash"></span> Delete Import & Sightings</button>
							</td>
						</tr>
					</tbody>
				</table>
				<Paging></Paging>
			</div>
			<div v-if="current_user && !current_user.profile.vetter">
				<div class="alert">
					<div class="alert__body">
						<span>Please login as a vetter to view imports.</span>
					</div>
				</div>
			</div>
			<div v-if="!current_user && !loading_user">
				<div class="alert">
					<div class="alert__body">
						<span>Please login to view imports.</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import global_data from '../../main';
	import FileUpload from 'vue-upload-component'
	export default {
		name: 'BulkUploadImportsComponent',
		metaInfo: {
			title: 'Bulk Upload Review',
		},
		data: function(){
			return {
				loading:true,
				loading_user: true,
				current_user: null,
				imports:[],
				page: 1,
				meta: {
					page: 0,
					per_page: 0,
					total_pages: 0,
					total_results: 0,
				},
			};
		},
		mounted: function(){
			var self = this;
			global_data.$on("user_changed", function(user){
				self.get_user();
			});
			self.get_user();
		},
		methods:{
			get_user: function(){
				var self = this;
				self.GetAPIUser(function(user){
					self.current_user = user;
					self.loading_user = false;
				}, true);
			},
			getData:function(){
				var self = this;

				var qs = "";
				qs += "&page=" + self.page;
				// qs += "&filter{status}=confirmed";
				qs += "&include[]=user.*";
				qs += "&per_page=10";
				qs += "&sort[]=-datetime";


				this.API({
					endpoint: 'imports',
					querystring: qs,
					funcThen: function(response){
						self.meta = response.data.meta;
						self.imports = self.mergeResponse(response.data);
						self.loading = false;
					},
				});
			},
			mergeResponse:function(responseData){
				for (var i = 0; i < responseData.imports.length; i++) {
					responseData.imports[i].user_data = responseData.users.find(u => u.id == responseData.imports[i].user);
					responseData.imports[i].action_id = 0;
				}
				return responseData.imports;
			},
			applyAction:function(upload){
				var self = this;
				if (upload.action_id == 0) {
					alert("Please select an option.");
					return;
				}

				if (upload.action_id == 1 && !confirm("Are you sure you want to Photo and Specimen records \"Accepted\", all Observed Only to \"Not Vetted\" for records in this import that currently have the status \"Pending Admin Review\"? This action cannot be undone.")) {
					return;
				}

				if (upload.action_id == 2 && !confirm("Are you sure you want to assign \"Pending\" or \"Not Vetted\" according to usual OC rules for records in this import that currently have the status \"Pending Admin Review\"? This action cannot be undone.")) {
					return;
				}

				if (upload.action_id == 3 && !confirm("Are you sure you want to assign \"Not Vetted\" to records in this import that currently have the status \"Pending Admin Review\"? This action cannot be undone.")) {
					return;
				}

				if (upload.action_id == 4 && !confirm("Are you sure you want to assign \"Not Vetted\" to to all records in this import? This action cannot be undone.")) {
					return;
				}

				this.loading = true;

				this.API({
					endpoint: 'imports/' + upload.id,
					isPatch:true,
					postData: {
						action:upload.action_id
					},
					funcThen: function(response){
						self.$notify({
							text: 'Import Updated',
							type: 'success',
						});
						self.getData();
					}
				});
			},
			deleteUpload:function(upload){
				if (!confirm("Are you sure you want to delete this import and all of it's associated sightings and checklists? This action cannot be undone.")) {
					return;
				}

				this.API({
					endpoint: 'imports/' + upload.id,
					isDelete:true,
					funcThen: function(response){
						self.$notify({
						  text: 'Import Deleted',
						  type: 'success',
						});
						self.$emit('importDeleted', upload.id);
						self.getData();
					},
					funcCatch: function(error){
						self.notifyError(error.response.data);
					},
				});
			},
		},
		computed:{
			max_page: function(){
				return this.meta.total_pages;
			}
		},
		watch:{
			page: function(){
				let query = Object.assign({}, this.$route.query);
				query.page = this.page;
				this.$router.replace({query: query});
				this.getData();
			},
			loading_user: function(){
				this.getData();
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/pages/BulkUploadImports.vue